import dashboardRouterPaths from './dashboardRouterPaths';

export default dashboardRouterPaths;
